<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <CreateHistoryTask/>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h5>Таблица связей препаратов (003ms)</h5>
      </div>
      <div class="card-body">
        <div class="text-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    ref="Pagination"
                    :page-range="11"
                    :margin-pages="2"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <table class="table table-hover table-sm" v-if="!loading">
          <thead>
          <tr>
            <th></th>
            <th>Препарат</th>
            <th>Регистрация</th>
            <th class="w-50">Связь</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(r,i) in records">
            <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
            <td>{{ r.title }}</td>
            <td>{{ printRegistration(r) }}</td>
            <td>
              <Search
                ref="search"
                :customPreset="{placeholder:'Поиск препарата'}"
                searchType="003_drugs"
                :onSelect="(record) => addDrug(r.id, record)"
              />
              <div>
                <div class="flex justify-content-between mt-1 border-bottom" v-for="(d, index) in relatedDrugs[r.id]">
                  <div>
                    <p>{{ d.title }}</p>
                    <p class="text-muted">{{ d.group }}</p>
                  </div>
                  <button @click="removeRelatedDrug(r.id, index)" class="btn btn-default"><i
                    class="icon-fa icon-fa-trash-o" aria-hidden="true"/></button>
                </div>
              </div>
            </td>
            <td>
              <LoadingButton
                title="Сохранить"
                :loading="btnLoading[r.id]"
                :color="$constants.SUCCESS_COLOR"
                :onClick="() => updateRelation(r.id)"
                className="btn btn-outline-success"
              />
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import Search from "@/components/search/Search.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import CreateHistoryTask from "@/views/tasks/components/CreateHistoryTask.vue";

export default {
  title: 'Связи препаратов',
  components: {
    CreateHistoryTask,
    LoadingButton,
    Search,
    Paginate,
  },
  data() {
    return {
      loading: false,
      paginator: null,
      records: [],
      relatedDrugs: {},
      btnLoading: {},
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    async updateRelation(drugId) {
      this.btnLoading[drugId] = true;
      this.btnLoading = {...this.btnLoading};
      const {data} = await api.post('/new/nomenclature/relations/update', {
        drug_id: drugId,
        relation_type: 1,
        records: this.relatedDrugs[drugId].map((r) => r.id)
      });
      if (data.success) {
        toastr['success']('сохранено', 'Успешно');
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.btnLoading[drugId] = false;
    },
    removeRelatedDrug(drugId, index) {
      delete this.relatedDrugs[drugId][index];
      this.relatedDrugs[drugId] = this.relatedDrugs[drugId].filter((r) => r);
    },
    addDrug(drugId, record) {
      if (!record) return;
      if (!this.relatedDrugs[drugId]) this.$set(this.relatedDrugs, drugId, []);
      if (this.relatedDrugs[drugId].find((r) => r.id === record.id)) return;
      this.relatedDrugs[drugId].push(record);
    },
    printRegistration(record) {
      const registration = record.details.find((d) => d.alias === 'use');
      if (registration?.int_value) return 'Есть регистрация';
      return '';
    },
    async getRecords(page = 1) {
      this.loading = true;
      let {data: r_data} = await api.post('/new/nomenclature/relations', {
        page,
        filter: {
          type: 1,
          hideWithRelation: true,
        }
      });
      if (r_data.success) {
        const {data, ...pagination} = r_data.records
        this.paginator = pagination;
        this.records = data;
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
